import { z } from 'zod';

const tableEntrySchema = z.object({
  kind: z.literal("table"),
  cells: z.record(z.string(), z.string().optional()).default({})
});

export { tableEntrySchema };
//# sourceMappingURL=TableEntry.js.map
